import { Box, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import * as React from "react";
import { useRecoilValue } from "recoil";

import { PropertyEditCurrentValue } from "@/components/property_edit/PropertyEditHistoryRow";
import { PropertyEditLayout as BaseTemplate } from "@/components/property_edit/PropertyEditLayout";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { ManagementCostHistoryEditor } from "./HistoryEditor";
import { ManagementCostHistoryItem } from "./HistroyItem";
import { ManagementCostType } from "./types";

interface EditPropertySectionManagementCostProps {
  costType: ManagementCostType;
  onClickPageBack: () => void;
}

export const EditPropertySectionManagementCostHistory: React.FC<EditPropertySectionManagementCostProps> = ({
  costType,
  onClickPageBack,
}) => {
  // 選択済み物件取得
  const selected_property = useRecoilValue(SelectedProperty);
  const [recordVersion, setRecordVersion] = React.useState(0);
  const handleOnCreate = () => setRecordVersion((version) => version + 1);

  const getCostByType = (costType: ManagementCostType, data: any) => {
    switch (costType) {
      case "賃貸管理費":
        return data.management_cost;
      case "建物管理費":
        return data.building_management_cost;
      case "修繕積立金":
        return data.repair_fund_cost;
      case "通信費":
        return data.communication_cost;
      case "その他経費":
      case "その他の経費":
        return data.misc_cost;
      case "固定資産税・都市計画税":
        return data.property_tax;
      case "消耗品費":
        return data.supplies_cost;
      case "設備修繕、大規模修繕費用":
        return data.large_scale_repair_fund_cost;
      case "その他一過性の支出":
        return data.misc_onetime_cost;
      default:
        return undefined;
    }
  };

  const filteredAndSortedResults =
    selected_property?.user_input_monthly_cashflow_results
      ?.filter((result) => {
        const cost = getCostByType(costType, result);
        return cost !== undefined && cost !== null;
      })
      .sort((a, b) => new Date(b.month).getTime() - new Date(a.month).getTime()) || [];

  // 最新のデータ（最初の1件）と過去のデータ（2件目以降）を分離
  const latestResult = filteredAndSortedResults[0];

  return (
    <BaseTemplate headerTitle={costType} onBack={onClickPageBack} backLabel="毎月の経費" isBackGroundWhite>
      <PropertyEditCurrentValue
        value={latestResult ? `${Number(getCostByType(costType, latestResult)).toLocaleString()}円` : "未登録"}
        since={latestResult ? dayjs(latestResult.month).format("YYYY年M月") : undefined}
      />
      <Typography component="h3" data-edit-section>
        変更を記録する
      </Typography>
      <ManagementCostHistoryEditor
        key={recordVersion}
        costType={costType}
        onCancel={onClickPageBack}
        onCreate={handleOnCreate}
        propertyBoughtAt={selected_property?.property.bought_at || ""}
      />
      <Box mt={4}>
        <Typography component="h3" data-edit-section>
          これまでの金額
        </Typography>
        {filteredAndSortedResults.map((result) => (
          <ManagementCostHistoryItem key={result.month} monthlyCashflowResult={result} costType={costType} />
        ))}
        <Typography variant="body2" color="textSecondary">
          行をタップすると、その期間の金額を直したり削除したりできます。
        </Typography>
      </Box>
    </BaseTemplate>
  );
};
